import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center text-center px-4">
      <div>
        <div className="eyebrow mb-3">404</div>
        <h1 className="font-display text-5xl md:text-6xl font-semibold text-[#1A1A1A]">Page not found</h1>
        <p className="text-[#4B4B4B] mt-4">The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn-primary mt-7">Back to Home</Link>
      </div>
    </div>
  );
}
